export const TABLES = {
  PROPERTIES: {
    collateralProperty: "Is this property additional collateral?",
    street: "Property Address",
    subordinateFinancingAmount: "Subordinate Financing",
    purchasedPrice: "Purchase Price",
    lotValue: "Refinance Price",
    downPayment: "Land Financed Amount - Purchase",
    mortgagePayout: "Land Financed Amount - Refinance",
    propertyType: "Current Property Type",
    borrowerOrganization: "Borrower",
    name: "Project Name",
    applicationNumber: "Application #",
    loanNumber: "Loan #",
    coodate: "Certificate Of Occupancy Date",
    outOfPocket: "Cost Paid to Date",
    nwccproject: "Inspection Company Project",
    permitStatus: "Permit Issued",
    tpvaluationDate: "3rd Party Valuation Date",
    tpvaluationProvider: "3rd Party Valuation Provider",
    eeadyForNwcc: "Ready For Work Inspection",
    nwccprojectNo: "Inspection Company Project No",
    isBudgetFrozenYesNo: "Is Budget Frozen",
    allUnitsPaidYesNo: "All Units Paid",
    workStage: "% of Work Complete",
    additionalCollateralDotnumber: "Additional Collateral DOT Number",
    additionalCollateralDotrecorded: "Additional Collateral DOT Recorded",
    brms: "BRMs",
    initialCos: "Initial COs",
    reviewCos: "Review COs",
    readyForNwcc: "Ready For Work Inspection",
    needsBorrowerApprovalBeforeSubmit: "Borrower Review Inspection Prior To Funding",
  },
  CONDITIONS: {
    description: "Condition",
    conditionTiming: "Timing",
    conditionStatus: "Status",
    escrowInstruction: "Use as Escrow Instruction",
    loanNumber: "Loan #",
    applicationNumber: "Application #",
    borrowerOrganization: "Borrower",
    isAutoAddedYesNo: "Is Auto Added",
    brms: "BRMs",
    initialCos: "Initial COs",
    reviewCos: "Review COs"
  }
};